import { useMemo } from 'react';

type MatchResult<T> = T & { isMatched: boolean };

export const useFindMatchesAndMismatches = <T extends { id: number }>(
  array: ReadonlyArray<T>,
  refs: ReadonlyArray<number>
): {
  matches: Array<MatchResult<T>>;
  mismatches: Array<MatchResult<T>>;
} => {
  return useMemo(() => {
    const refsSet = new Set(refs);

    const matches = [];
    const mismatches = [];

    for (const item of array) {
      if (refsSet.has(item.id)) {
        matches.push({ ...item, isMatched: true });
      } else {
        mismatches.push({ ...item, isMatched: false });
      }
    }

    return {
      matches,
      mismatches,
    };
  }, [array, refs]);
};
